import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutCTA() {
  const ctaRef = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-20" style={{ background: '#fafafa' }}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ctaRef}
          className="rounded-2xl overflow-hidden flex flex-col lg:flex-row items-center gap-0 scroll-animate-fade-up"
          style={{ background: '#0f0f0f', border: '1px solid #2a2a2a' }}
        >
          <div className="lg:w-2/5 h-64 lg:h-auto w-full overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/8659ad6de201857cbdb4294685727dab.jpg"
              alt="Book a free consultation with Benny Legacy"
              className="w-full h-full object-cover object-top"
              style={{ minHeight: '320px' }}
            />
          </div>
          <div className="flex-1 p-8 sm:p-12 text-center lg:text-left">
            <p className="text-xs font-bold tracking-[0.35em] uppercase mb-3" style={{ color: '#B8860B' }}>
              Ready to Start?
            </p>
            <h2 className="text-2xl sm:text-3xl font-extrabold mb-4 leading-tight text-white">
              Let's Build Your <br />
              <span style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Legacy Together
              </span>
            </h2>
            <p className="text-sm leading-relaxed mb-8" style={{ color: '#aaaaaa' }}>
              Book a free 30 minute consultation with Benny and get a personalized game plan built around your goals, schedule, and lifestyle. No pressure. No sales pitch. Just real talk about what it takes to transform.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="/#booking"
                className="inline-block px-8 py-3.5 rounded-md font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
                style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', color: '#000000' }}
              >
                Book Free Consultation
              </a>
              <a
                href="/programs"
                className="inline-block px-8 py-3.5 rounded-md font-bold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
                style={{ border: '2px solid #B8860B', color: '#F5D76E', background: 'transparent' }}
                onMouseEnter={e => {
                  e.currentTarget.style.background = 'rgba(184,134,11,0.1)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background = 'transparent';
                }}
              >
                View Packages
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}